import { useEffect, useState } from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";

import {
  getAllProductCategories,
  findProduct,
} from "../../../../../api/userRegestration/CollectionForm";
export default function Inputform() {
  const [categories, setCategories] = useState([]);
  const accessToken = localStorage.getItem("token");
  const [formData, setFormData] = useState({
    category: "",
    Productrate: "",
    moq: "",
    mqunit: "",
    ProductDetail: "",
    shareBusinessCard: false,
    followGuidelines: false,
  });
// 
const handleInputChange = (event) => {
  const { name, value, type, checked } = event.target;
  const newValue = type === "checkbox" ? checked : value;
  setFormData({ ...formData, [name]: newValue });
};

const handleSubmit = async (event) => {
  event.preventDefault();
  try {
    const produtdata = {
      productName: "Car",
      mediaUrl:
        "data:image/jpeg;base64,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",
      details: "honda civic",
      amount: "3",
      mediaType: "MEDIA",
      categorie: "iphone",
    };
    const Product = await findProduct(produtdata);
    console.log("post:", Product);
  } catch (error) {
    console.error("Error in :", error.message);
  }
};


// 
  useEffect(() => {
    getAllProductCategories(accessToken)
      .then((result) => {
        setCategories(result);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [accessToken]);
  return (
    <>
      <div className="form">
      <form onSubmit={handleSubmit}>
          <div className="flex sm:flex-row  md:flex-row  flex-col lg:gap-[9rem] mt-[3rem] mb-[2rem]">
            {/* 1 */}
            <div className="form-input flex flex-col  w-[47%]">
              <div className="coolinput flex flex-col w-fit-content static max-w-240 lg:w-[541px] ml-[2.1rem]">
                <label
                  htmlFor="select"
                  className="text text-sm text-black w-[8rem] rounded-md bg-[white] relative top-2.5 ml-2 px-1 bg-w-fit-content text-center"
                >
                  Product Categories
                </label>
                <select
                  name="category"
                  className="input px-2 py-3 text-sm border-[1px] border-[#738482] rounded-md focus:border-[1px] p-[10px]"
                  value={formData.category}
                  onChange={handleInputChange}
                >
                  <option value="" className="p-2" disabled>
                    Select Category
                  </option>
                  {categories.map((category) => (
                    <option
                      key={category._id}
                      value={category.name}
                      className="bg-white  transition-colors duration-300 p-2"
                    >
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
              {/* 2  */}
              <div className="coolinput flex flex-col w-fit-content static max-w-240 lg:w-[541px]  ml-[2.1rem] ">
                <label
                  htmlFor="input"
                  className=" text text-sm  text-black w-[6rem] rounded-md  bg-[white] relative top-2.5 ml-2 px-1 bg- w-fit-content text-center"
                >
                  Product Rate
                </label>
                <input
                  type="text"
                  placeholder="Write here..."
                  name="Productrate"
                  className="input px-2 py-3 text-sm border-[1px] border-[#738482] rounded-md focus:border-[1px] p-[10px]"
                  value={formData.Productrate}
                  onChange={handleInputChange}
                />
              </div>{" "}
              {/*  */}
              <div className="coolinput flex flex-col w-fit-content static max-w-240 lg:w-[541px]  ml-[2.1rem] ">
                <label
                  htmlFor="input"
                  className=" text text-sm  text-black w-[10rem] rounded-md  bg-[white] relative top-2.5 ml-2 px-1 bg- w-fit-content text-center"
                >
                  Minimum Order Quanity
                </label>
                <input
                  type="text"
                  placeholder="Write here..."
                  name="moq"
                  className="input px-2 py-3 text-sm border-[1px] border-[#738482] rounded-md focus:border-[1px] p-[10px]"
                  aria-autocomplete="list"
                  value={formData.moq}
                  onChange={handleInputChange}
                />
              </div>{" "}
              <div className="coolinput flex flex-col w-fit-content static max-w-240 lg:w-[541px]  ml-[2.1rem] ">
                <label
                  htmlFor="input"
                  className=" text text-sm  text-black w-[5rem] rounded-md  bg-[white] relative top-2.5 ml-2 px-1 bg- w-fit-content text-center"
                >
                  MQ UNIT
                </label>
                <input
                  type="text"
                  placeholder="Write here..."
                  name="mqunit"
                  className="input px-2 py-3 text-sm border-[1px] border-[#738482] rounded-md focus:border-[1px] p-[10px]"
                  value={formData.mqunit}
                  onChange={handleInputChange}
                />
              </div>{" "}
              {/*  */}
              {/* 5  */}
              {/* text area  */}
              <div className="coolinput flex flex-col w-fit-content static max-w-240 lg:w-[541px] ml-[2.1rem]">
                <label
                  htmlFor="input"
                  className="text text-sm text-black w-[7rem] rounded-md bg-[white] relative top-2.5 ml-2 px-1 bg- w-fit-content text-center"
                >
                  Product Details
                </label>
                <textarea
                  placeholder="Write here..."
                  name="ProductDetail"
                  rows="7"
                  className="input px-2 py-3 text-sm border-[1px] border-[#738482] rounded-md focus:border-[1px] p-[10px]"
                  value={formData.ProductDetail}
                  onChange={handleInputChange}
                ></textarea>
              </div>
            </div>

            {/* 2 */}

            <div className="inline-flex flex-col mt-[4rem] lg:gap-[3rem]">
              <div className=" rounded-md h-1/3 border-[1.5px] border-dashed border-black ">
                <div className="flex justify-center bg-white w-[60%]  mx-auto mt-[-12px] rounded-full">
                  Attach Supporting Document
                </div>

                <div className="button">
                  <AiOutlinePlusCircle className="text-[33px] mx-auto mt-[2rem]" />
                </div>
              </div>

              <div className="/">
                <div class="flex items-center ">
                  <input
                    id="link-checkbox"
                    type="checkbox"
                    value=""
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    for="link-checkbox"
                    class="ml-2 text-sm font-all font-semibold text-gray-900 dark:text-gray-300"
                  >
                    I agree to share my Bussiness card with Supplier .
                  </label>
                </div>

                <div class="flex items-center mt-3">
                  <input
                    id="link-checkbox"
                    type="checkbox"
                    value=""
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    for="link-checkbox"
                    class="ml-2 text-sm font-all font-semibold text-gray-900 dark:text-gray-300"
                  >
                    I agree to follow buyer posting guideline .
                  </label>
                </div>
              </div>

              {/* buttin action */}

              <div class="button-action flex flex-col items-center mt-6">
                <button
                  type="submit"
                  class=" bg-[#CB2229] text-white rounded-full font-all p-[6px] lg:mt-[0.5rem] w-[18rem]   transform hover:scale-105 duration-500 ease-in-out relative"
                >
                  Share Inputs{" "}
                </button>
                <button class="mb-6 border-[1px] border-[#CB2229] text-black rounded-full font-all p-[6px] lg:mt-[0.5rem] w-[18rem]   transform hover:scale-105 duration-500 ease-in-out relative  ">
                  Create a Campaign
                </button>
              </div>
            </div>
            {/*  */}
          </div>
        </form>
      </div>
    </>
  );
}
